// extracted by mini-css-extract-plugin
module.exports = {"container":"styles__container___W9gm1","menuItem":"styles__menuItem___1uSNS","text":"styles__text___3BGZG","count":"styles__count___2s7Dk"};